export default __webpack_public_path__ + "images/funnel-chart-dummy-140.ae6915c9a8a7b21964394bc3df198226.svg";